<template>
  <div style="height: 100%">
    <img class="attendance-bg" src="../assets/images/bg.jpg" alt="" />
    <div class="attendance">
      <div class="attendance-title">
        湖北升本信息服务中心
        <span class="date-item">
          <el-date-picker
            class="date-text test-item"
            v-model="timeOb"
            clear-icon="el-icon-date"
            type="date"
            placeholder="选择日期"
            @change="changeDateGo"
          >
          </el-date-picker>
          <i class="el-icon-caret-bottom el_icon_down"></i>
        </span>
        学员出勤雷达监测表
      </div>
      <div class="attendance-main">
        <div class="left-table">
          <div class="atten-class-table">
            <p class="table-tt">上课班级出勤率排名</p>
            <div class="table-box">
              <div class="table-thead">
                <dl>
                  <dt>排名</dt>
                  <dt>班级名称</dt>
                  <dt>实时出勤率</dt>
                </dl>
              </div>
              <div class="table-tbody tgRoll">
                <div>
                  <dl v-for="(item, index) in attendanceRanking" :key="index">
                    <dd>
                      <i v-if="index == 0" class="ranking-one"></i>
                      <i v-else-if="index == 1" class="ranking-two"></i>
                      <span v-else>{{ index + 1 }}</span>
                    </dd>
                    <dd>{{ item.gradeName }}</dd>
                    <dd>{{ item.ranking }}%</dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
          <div class="integral-box">
            <p class="table-tt">班级【小组】学习积分（金币）排行榜</p>
            <div class="integral-inner">
              <div class="carousel slide integral_carousel">
                <el-carousel arrow="never" indicator-position="outside">
                  <el-carousel-item
                    v-for="(itm, index) in gradeGroupIntegralDtos"
                    :key="index"
                  >
                    <div v-for="item in itm" class="item" :key="item.index">
                      <div class="table-box">
                        <div class="table-thead">
                          <dl class="table-class-tt">
                            
                            <dt v-if="item.gradeTitle">{{ item.gradeTitle }}</dt>
                            <dt v-else class="gray">未设置</dt>
                            
                          </dl>
                          <dl>
                            <dt>组名</dt>
                            <dt>总金币</dt>
                            <dt>组长</dt>
                            <dt>排名</dt>
                          </dl>
                        </div>
                        <div class="table-tbody tgRoll">
                          <div>
                            <dl v-for="it in item.integrals" :key="it.index">
                              <dd>{{ it.integralTeamName }}</dd>
                              <dd>{{ it.totalScore }}枚</dd>
                              <dd>{{ it.groupLeader || "未设置" }}</dd>
                              <dd>
                                <i
                                  v-if="it.order === 1"
                                  class="ranking-one"
                                ></i>
                                <i
                                  v-else-if="it.order === 2"
                                  class="ranking-two"
                                ></i>
                                <i
                                  v-else
                                  :class="it.order === 0 ? 'gray' : ''"
                                  >{{ it.order || "暂无排名" }}</i
                                >
                              </dd>
                            </dl>
                            <!-- <dl>
                              <dd>4组</dd>
                              <dd>1300枚</dd>
                              <dd>88枚</dd>
                              <dd><i class="ranking-two"></i></dd>
                            </dl> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </div>
        </div>
        <div class="divide3 center-table">
          <p class="table-tt">全校早到榜前20名</p>
          <div class="table-box">
            <div class="table-thead">
              <dl>
                <dt>姓名</dt>
                <dt>全校排名</dt>
                <dt>时间</dt>
              </dl>
            </div>
            <div class="table-tbody tgRoll">
              <div>
                <dl v-for="(item, index) in earlyArrival" :key="index">
                  <dd>{{ item.studentName }}</dd>
                  <dd>{{ item.order }}</dd>
                  <dd>{{ item.signTime | signTime }}</dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
        <div class="right-table">
          <div class="late-table lateTable">
            <p class="table-tt">
              今日迟到榜前<span class="num-text">20</span>名
            </p>
            <div class="table-box">
              <div class="table-thead">
                <dl>
                  <dt>姓名</dt>
                  <dt>所在班级</dt>
                  <dt>迟到时间</dt>
                </dl>
              </div>
              <div class="table-tbody tgRoll">
                <div>
                  <dl v-for="(item, index) in studentLateRanking" :key="index">
                    <dd>{{ item.studentName }}</dd>
                    <dd>{{ item.gradeName }}</dd>
                    <dd class="timeout-text">{{ item.lateMinutes }}分钟</dd>
                  </dl>
                  <!-- <dl>
                    <dd>李娜</dd>
                    <dd>特训4班</dd>
                    <dd>2分钟</dd>
                  </dl> -->
                </div>
              </div>
            </div>
          </div>
          <div class="integral-box">
            <p class="table-tt">班级【个人】学习积分（金币）排行榜</p>
            <div class="integral-inner">
              <div class="carousel slide integral_carousel">
                <el-carousel arrow="never" indicator-position="outside">
                  <el-carousel-item
                    type="card"
                    v-for="(ite, index) in gradeIntegraMemberDataDtos"
                    :key="index"
                  >
                    <div v-for="(item, index) in ite" class="item" :key="index">
                    
                      <div class="table-box">
                        <div class="table-thead">
                          <dl class="table-class-tt">
                            <dt v-if="item.gradeTitle">{{ item.gradeTitle?item.gradeTitle:'未设置' }}</dt>
                            <dt v-else class="gray">未设置</dt>
                            
                          </dl>
                          <dl>
                            <dt>姓名</dt>
                            <dt>所在小组</dt>
                            <dt>总金币</dt>
                            <dt>排名</dt>
                          </dl>
                        </div>
                        <div class="table-tbody tgRoll" >
                          <div v-if="item.integralMembers">
                            <dl
                              v-for="it in item.integralMembers"
                              :key="it.studentId"
                            >
                              <dd
                                :class="
                                  it.studentName && it.studentName.length > 0
                                    ? ''
                                    : 'gray'
                                "
                              >
                                {{ it.studentName || "未填写" }}
                              </dd>
                              <dd>{{ it.integralTeamName }}</dd>
                              <dd>{{ it.totalScore }}枚</dd>
                              <dd>
                                <i
                                  v-if="it.order === 1"
                                  class="ranking-one"
                                ></i>
                                <i
                                  v-else-if="it.order === 2"
                                  class="ranking-two"
                                ></i>
                                <i
                                  v-else
                                  :class="it.order === 0 ? 'gray' : ''"
                                  >{{ it.order || "暂无排名" }}</i
                                >
                              </dd>
                            </dl>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="todayMessagesList.length > 0" class="attendance-footer">
        <span class="word-tt">今日寄语：</span>
        <div class="word-list" id="tgCars">
          <ul ref="tgars">
            <li v-for="(item, index) in todayMessagesList" :key="index">
              <span>{{ item.key }}</span>
              <span> 寄语:{{ item.value }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// jQuery
import $ from "jquery";
import { AttendanceMonitoringMap } from "network/radar";
import { timeFormatNew,isNull } from "common/utils";
export default {
  name: "RadarStudentsAttendance",
  data() {
    return {
      timeOb: new Date(),
      attendanceRanking: [], //出勤率
      earlyArrival: [], //今日全校早到榜前20名
      gradeGroupIntegralDtos: [
        // {
        //   gradeId: 1,
        //   gradeTitle: null,
        //   integrals: [],
        // },
        // {
        //    gradeId: 2,
        //   gradeTitle: null,
        //   integrals: [],
        // },
        // {
        //   gradeId: 3,
        //   gradeTitle: null,
        //   integrals: [],
        // },
        // {
        //   gradeId: 4,
        //   gradeTitle: null,
        //   integrals: [],
        // }
      ], //班级小组学习积分（金币）排行榜
      gradeIntegraMemberDataDtos: [], //小组学员个人学习积分（金币）排行榜
      studentLateRanking: [], //今日迟到榜前20名
      todayMessagesList: [],
      urlTime: "",
      timer: null,
    };
  },
  filters: {
    signTime(tiem) {
      return timeFormatNew(tiem, "hh:mm");
    },
  },
  computed: {},
  created() {
    //定时刷新页面：每天中午12点前每15s刷新一次
    // var now = new Date().getHours();
    // if (now > 7 && now < 12) {
    //   var timer = setTimeout(function () {
    //     location.reload();
    //   }, 15000); //15s刷新一次
    // } else {
    //   clearTimeout(timer);
    // }
    let that = this;
    // 排行榜滚动
    var time = setInterval(function () {
      that.Scroll();
    }, 5000);
  },
  mounted() {
    this.executionOrder();
  },
  methods: {
    isNull,
    async executionOrder() {
      let timeGet = timeFormatNew(this.timeOb, "yyyy-MM-dd");
      if (this.$route.query.dt) {
        this.timeOb = this.$route.query.dt;
        await this.getAttendanceMonitoringMap(this.$route.query.dt);
      } else {
        await this.getAttendanceMonitoringMap(timeGet);
      }
      this.$nextTick(() => {
        this.lunbo();
      });
    },
    Scroll() {
      $(".tgRoll").each(function () {
        var area = $(this);
        //单行高度
        var he = area.find("dl").height();
        //单次滚动行数
        // var lines = parseInt(area.height()/he);
        var lines = 4;
        if (area.height() >= area.find("dl").length * he) {
          return;
        } else {
          area.find("div").animate(
            {
              marginTop: "-" + he * lines,
            },
            200,
            function () {
              for (let i = 1; i <= lines; i++) {
                area.find("dl:first").appendTo(area.find("div"));
              }
              area.find("div").css({
                marginTop: 0,
              });
            }
          );
        }
      });
    },
    lunbo() {
      if (this.todayMessagesList.length > 0) {
        var oUl = $("#tgCars>ul")[0];
        var lis = oUl.getElementsByTagName("li");
        oUl.innerHTML += oUl.innerHTML;
        oUl.style.width = lis.length * lis[0].offsetWidth + "px";
        var left = null;
        this.timer = setInterval(function () {
          left -= 3;
          if (left < -oUl.offsetWidth / 2) {
            left = 0;
          }
          oUl.style.left = left + "px";
        }, 50);
      } else {
      }
    },
    // 获取数据
    async getAttendanceMonitoringMap(timeGet) {
      const res = await AttendanceMonitoringMap(timeGet);
      let result = JSON.parse(JSON.stringify(res.data))
      if (result.code === 1) {
        this.attendanceRanking = result.result.attendanceRanking;

        this.earlyArrival = result.result.earlyArrival;
        this.gradeGroupIntegralDtos = result.result.gradeGroupIntegralDtos;
        this.gradeIntegraMemberDataDtos = result.result.gradeIntegraMemberDataDtos
       
        this.studentLateRanking = result.result.studentLateRanking;
        this.todayMessagesList = result.result.todayMessagesList;
        // 格式化二维数组
        this.gradeIntegraMemberDataDtos = this.ceildata(this.gradeIntegraMemberDataDtos,4)
        this.gradeGroupIntegralDtos = this.ceildata(this.gradeGroupIntegralDtos,4)
        
      }
    },
    // 分组
    ceildata(arr,num){
      
      let list = []
      let numdata = Math.ceil(arr.length / num );
      for (var i = 0; i < numdata; i++) {
        const start = i * num;
				const end = start + num;
        list.push(arr.slice(start, end))
      }
			return list
			
    },
    changeDateGo(time) {
      this.timeOb = timeFormatNew(time, "yyyy-MM-dd");
      window.location.href = "/#/RadarStudentsAttendance?dt=" + this.timeOb;
      this.todayMessagesList = [];
      this.executionOrder();
    },
  },
};
</script>
<style scoped src="../assets/css/radar.css"></style>
<style scoped>
.left-table,
.center-table,
.right-table {
  display: inline-block;
  vertical-align: top;
  height: 100%;
  padding-top: 2%;
  box-sizing: border-box;
}

.right-table {
  width: 38%;
}

.left-table,
.center-table {
  margin-right: 2%;
}

/* @media screen and (max-width:1080px){
    html,body{min-width: 1080px;overflow-x: scroll;} 
    .attendance-bg{width: 1080px;}
    .left-table{width: 412px;}
    .center-table{width: 254px;}
    .right-table{width: 314px;}
    .left-table,.center-table{margin-right:20px;}
} */

.table-thead dl dt,
.table-tbody dl dd {
  float: left;
  font-size: 14px;
  padding: 5px;
  line-height: 24px;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 24%;
}
.lateTable .table-thead dl dt:first-child + dt,
.lateTable .table-tbody dl dd:first-child + dd {
  width: 49%;
}

.left-table .table-tbody,
.right-table .table-tbody {
  height: 83%;
}

.center-table .table-tbody {
  height: 95%;
}

.left-table .table-thead dl dt,
.left-table .table-tbody dl dd {
  width: 22%;
}

/*.left-table .table-thead dl dt:first-child,.left-table .table-thead dl dt:last-child,.left-table .table-tbody dl dd:first-child,.left-table .table-tbody dl dd:last-child{width: 20%;}
.left-table .table-thead dl dt:first-child,.left-table .table-thead dl dt:first-child+dt+dt+dt,.left-table .table-tbody dl dd:first-child,.left-table .table-tbody dl dd:first-child+dd+dd+dd{width: 20%;} IE兼容写法*/

.left-table .table-thead dl dt:first-child,
.left-table .table-tbody dl dd:first-child {
  width: 16%;
}

.left-table .table-thead dl dt:nth-child(2),
.left-table .table-tbody dl dd:nth-child(2) {
  width: 40%;
}

.left-table .table-thead dl dt:first-child + dt,
.left-table .table-tbody dl dd:first-child + dd {
  width: 40%;
}

.divide3 .table-thead dl dt,
.divide3 .table-tbody dl dd {
  width: 33.33%;
}

.table-tbody dl dd.timeout-text {
  color: #f04e4e;
}

.attendance-footer {
  width: 1440px;
  position: absolute;
  bottom: 15px;
  left: 50%;
  margin-left: -720px;
  text-align: left;
  padding: 0 30px;
  line-height: 36px;
}

.word-tt {
  color: #54ecff;
}

.word-list {
  font-size: 0;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  width: 1300px;
  height: 36px;
  overflow: hidden;
}

.word-list ul {
  position: absolute;
  left: 0;
  top: 0;
}

.word-list ul li {
  float: left;
  color: #fff;
  font-size: 14px;
  margin-right: 15px;
}

.atten-class-table,
.late-table {
  height: 32%;
}
.atten-class-table .table-tt,
.late-table .table-tt {
  height: 16%;
}
.atten-class-table .table-box,
.late-table .table-box {
  height: 84%;
}
.integral-box {
  height: 65%;
  overflow: hidden;
}
.integral-box .table-tt {
  margin-top: 4%;
  height: 6%;
}
.integral-inner {
  font-size: 0;
  height: 88%; /* overflow: hidden;display: flex;flex-direction: row; */
}
.integral-inner .carousel,
.integral-inner .carousel-inner,
.integral-inner .item {
  height: 100%;
}
.integral-inner .table-box {
  width: 100%;
  height: 100%;
}
.integral-inner .table-box:nth-child(2n) {
  margin-left: 1.5%;
}
.integral-inner .table-box dl.table-class-tt dt {
  width: 100% !important;
}
.integral-inner .table-box .table-tbody {
  height: 67%;
}
.integral-inner .carousel-indicators {
  width: 100px;
  left: auto;
  bottom: auto;
  right: 40px;
  top: -32px;
  margin-left: 0;
  text-align: right;
}
.integral-inner .carousel-indicators li {
  width: 6px;
  height: 6px;
  margin-right: 3px;
}
.integral-inner .carousel-indicators li.active {
  width: 8px;
  height: 8px;
}
.integral-inner .carousel-control {
  top: -36px;
  left: auto;
  right: 0;
  bottom: auto;
  width: 16px;
  height: 16px;
  display: inline-block;
  background: url(../assets/images/icon0.png) no-repeat;
  background-size: 145px auto;
}
/* .integral-inner .carousel-control:hover{background-color: rgba(255,255,255,0.6);} */
.integral-inner .carousel-control.left {
  right: 16px;
  background-position: -97px -50px;
}
.integral-inner .carousel-control.right {
  background-position: -117px -50px;
}

/* 轮播 */
>>> .el-carousel--horizontal {
  height: 100%;
  padding-top: 20px;
  overflow-y: hidden;
}
>>> .el-carousel__container {
  height: 100%;
}
.el-carousel__item {
  background: transparent;
}
>>> .el-carousel__indicators--outside {
  top: -106%;
  text-align: right;
  bottom: initial;
  position: relative;
}
>>> .el-carousel__button {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}
>>> .el-carousel__indicator.is-active button {
  width: 8px;
  height: 8px;
}
>>> .el-carousel__indicators--horizontal {
  left: auto;
}
.gray {
  color: #c0c0c0;
}
.integral-inner .item {
  width: 49.25%;
  float: left;
  margin-bottom: 1.5%;
  height: 48%;
  margin-right: 1.5%;
  overflow: hidden;
}
.integral-inner .item:nth-child(2n) {
  margin-right: 0;
}
.integral-inner .item:nth-child(3) {
  margin-bottom: 0;
}
.integral-inner .item:nth-child(4) {
  margin-bottom: 0;
}
</style>